// removed by extract-text-webpack-plugin
module.exports = {"magazines-preview":"magazines_3C9qg","toolbar":"magazines_3AIyN"};


//////////////////
// WEBPACK FOOTER
// ./src/components/publish/preview/MagazinePreview.scss
// module id = 620
// module chunks = 1